import * as uiActions from './UIActions';

export const INITIAL_STATE = {
  loading: false,
  tabSelecionada: ''
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case uiActions.SET_LOADING:
      return { ...state, loading: !state.loading };
    case uiActions.REMOVE_LOADING:
      return { ...state, loading: false };
    case uiActions.SET_TAB_SELECIONADA:
      return { ...state, tabSelecionada: action.payload };
    default:
      return state;
  }
};
